import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/eds-styles.min.css';
import '@gehc-eds-react/eds-navigation-side';
import '@gehc-eds-react/eds-masthead';
import '@gehc-eds-react/eds-icon';
import '@gehc-eds-react/eds-system-notification';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();